<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="user-tie" />
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <b-tabs>
      <b-tab :title="$t('profile')">
        <k-y-c-list></k-y-c-list>
      </b-tab>
      <b-tab :title="$t('misaLinked')" lazy>
        <k-y-c-list default-wesign-status="linked"></k-y-c-list>
      </b-tab>
      <b-tab :title="$t('contract')">
        <contract-list></contract-list>
      </b-tab>
      <b-tab v-if="canViewContractTemplate" :title="$t('contractTemplate')">
        <template-list></template-list>
      </b-tab>
    </b-tabs>
  </main>
</template>

<script>
import KYCList from './KYCList';
import ContractList from "./ContractList.vue";
import TemplateList from "./contract-template/TemplateList.vue";
export default {
  components: {ContractList, KYCList, TemplateList},
  computed: {
    // Tab "Mẫu hợp đồng" gọi /kyc-contract-template — endpoint chỉ mở cho nhóm role dưới đây
    // (ROLE_VIEW trong routes/kyc-contract-template.js). Role ngoài nhóm (ctvSales, manager,
    // supervisor...) trước đây vẫn thấy tab rồi ăn 403 ngay khi mở màn. Ẩn tab thay vì nới quyền:
    // xuất PDF hợp đồng dùng endpoint khác (/client-kyc/contract-templates) nên không bị ảnh hưởng.
    canViewContractTemplate() {
      const role = this.$store.state.user && this.$store.state.user.role;
      return ['owner', 'admin', 'tech', 'account', 'operationsManager', 'accountant', 'sales', 'am'].includes(role);
    },
  },
  i18n: {
    messages: {
      en: {
        title: "Client profile",
        profile: "Profile",
        misaLinked: "MISA-linked profiles",
        contract: "Contract",
        contractTemplate: "Contract templates",
      },
      vi: {
        title: "Hồ sơ khách hàng",
        profile: "Hồ sơ",
        misaLinked: "Hồ sơ liên kết MISA",
        contract: "Hợp đồng",
        contractTemplate: "Mẫu hợp đồng",
      }
    }
  }
}
</script>